// Centralized document.title handling (VLT-1973)
// The base reflects which app the user is in ("Voltie Admin" / "Voltie Dashboard"),
// and setPageTitle prepends the current page name, e.g. "Chargers - Voltie Admin"
// or "Tomi's charger - Settings - Voltie Admin".

const APP_NAME = 'Voltie'

let base = APP_NAME

export function setTitleBase(isAdmin: boolean) {
  base = `${APP_NAME} ${isAdmin ? 'Admin' : 'Dashboard'}`
}

export function setPageTitle(pageName?: string) {
  document.title = pageName ? `${pageName} - ${base}` : base
}

// When a charger has no real name (its name equals its ID), show only the last four digits
// of the ID instead of the full ID
export function chargerTitleName(localName: string, chargerId: string): string {
  return localName === chargerId ? chargerId.slice(-4) : localName
}

// Maps a static (non data-dependent) route to its existing menu translation key.
// Returns null for routes whose title depends on fetched data (charger detail, charger logs),
// which set their own title from within the page component.
export function getStaticTitleKey(pathname: string): string | null {
  if (pathname.startsWith('/chargers/')) return null
  if (pathname.startsWith('/logs/')) return null
  if (pathname.startsWith('/users/')) return null

  switch (pathname.split('/')[1]) {
    case '': return 'menu_dashboard'
    case 'chargers': return 'menu_chargers'
    case 'rfids': return 'menu_rfids'
    case 'chargergroups': return 'menu_chargerGroups'
    case 'errorlogs': return 'menu_errorLogs'
    case 'appversion': return 'menu_appVersion'
    case 'users': return 'menu_users'
    case 'settings': return 'menu_settings'
    case 'notifications': return 'menu_notifications'
    default: return null
  }
}
